var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4826 9.68989L13.1237 0.40244C13.042 0.335388 12.9448 0.282192 12.8379 0.245896C12.7309 0.2096 12.6163 0.190918 12.5005 0.190918C12.3847 0.190918 12.2701 0.2096 12.1632 0.245896C12.0562 0.282192 11.9591 0.335388 11.8773 0.40244L0.518442 9.68989C0.187522 9.96067 0 10.3285 0 10.7121C0 11.5086 0.791451 12.1562 1.76491 12.1562H2.96174V18.7833C2.96174 19.1827 3.35608 19.5054 3.84419 19.5054H10.7356V14.451H13.8242V19.5054H21.1568C21.645 19.5054 22.0393 19.1827 22.0393 18.7833V12.1562H23.2361C23.7049 12.1562 24.1544 12.005 24.4853 11.732C25.172 11.1679 25.172 10.254 24.4826 9.68989Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.56d55d472dc5af68e242d2bd9bbd3fe1.svg";
export { ForwardRef as ReactComponent };